/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Created by Andrey Gayvoronsky on 13/04/16.
 */
const locale = {
  placeholder: 'Выберите время'
};

export default locale;
